import React from 'react';
import PropTypes from 'prop-types';

import Card from './card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AdditionalSyndication from './additional_syndication';
import EmptyState from 'components/project/empty_state';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';

export default class Syndication extends React.Component {
  static propTypes = {
    fullScreen: PropTypes.bool,
    syndicationPartners: PropTypes.array,
    onSetAsActive: PropTypes.func.isRequired
  }

  renderEmptyState() {
    return (
      <EmptyState
        message="This listing is not currently syndicated."
      />
    );
  }

  renderBlurb() {
    return <div className="syndication-box">
      <p className="header">
        <i>
          Published on the Buildout Syndication Network, including these channels:
        </i>
      </p>
    </div>;
  }

  renderPartnerTable() {
    const topEight = this.props.syndicationPartners.slice(0, 8).sort((a, b) => a.order - b.order);
    const imagesRows = [];
    for (const partner of topEight) {
      imagesRows.push(
        <div className="banner-container" key={partner.name}>
          <FontAwesomeIcon className="banner-check" icon={faCircleCheck} />
          <img className="banner-img" src={partner.banner}></img>
        </div>
      );
    }

    return <div>
      <div className="banner-table">
        {imagesRows}
      </div>
    </div>;
  }

  renderBody() {
    if (this.props.syndicationPartners.length == 0) {
      return this.renderEmptyState();
    } else {
      if (!this.props.fullScreen) {
        return <div className="syndication-body">
          {this.renderBlurb()}
          {this.renderPartnerTable()}
        </div>;
      } else {
        return <AdditionalSyndication expand syndicationPartners={this.props.syndicationPartners} />;
      }
    }
  }


  render() {
    const { onSetAsActive, syndicationPartners, ...passThroughProps } = this.props;

    return (
      <Card
        {...passThroughProps}
        loading={!syndicationPartners}
        subtitle="Overview of 3rd party listing site distribution"
        title="Listing Site Syndication"
        onSetAsActive={onSetAsActive}
      >
        {syndicationPartners && this.renderBody()}
      </Card>
    );
  }
}
